import Styles from "./OurServices.module.css";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import moment from "moment";
import FileSaver from "file-saver";
import toast from "react-hot-toast";
import {
  base64DownloadService,
  QrCodeDownloadService,
  UPIQrCodeService,
} from "../../../Services/ApiServices";
import Loader from "../../../SharedComponents/Loader/Loader";
import { useSelector } from "react-redux";
import { Confirmation } from "../../../Modal/Confirmation";
import {
  base64ToBlob,
  parseBase64Response,
  planActiveText,
} from "../../../Utility/Utility";
import BrochureActionModal from "../../../Modal/BrochureActionModal";

export default function OurServices(props) {
  let navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const DashboardData = useSelector((state) => state.dashboard_details);
  const [showWarning, setShowWarning] = useState(false);
  const [showBrochureModal, setShowBrochureModal] = useState(false);

  const handleService = (data) => {
    switch (data) {
      case "products":
        return navigate("/store/products", {
          state: 2,
        });
      case "Product Billing":
        if (DashboardData?.subscription_status) {
          return navigate("/store/categories", {
            state: 1,
          });
        } else {
          setShowWarning(true);
          return;
        }

      case "Payment Request":
        return navigate("/store/payment_request");
      case "Stock List":
        return navigate("/store/inventory_list", { state: 1 });
      case "Invoice":
        return navigate("/store/bill_list");
      case "My Order":
        return navigate("/store/myorder");
      case "Complaints":
        return navigate("/store/list_complaint");
      case "e-Brochure":
        return setShowBrochureModal(true);
      // case "UPI-QR Code":
      //   return handleupiQrCode();
      case "Brochure User":
        return navigate("/store/brochure_user");
      case "Customer Order Request":
        return navigate("/store/customerOrderrequest");
    }
  };

  const handleQrcode = () => {
    setIsLoader(true);
    QrCodeDownloadService()
      .then((res) => {
        let url = res.data.url;
        let urlArr = url.split(".");
        let ext = urlArr[urlArr.length - 1];
        let dateTime =
          moment().format("DD-MM-YYYY") + "," + moment().format("hh:mm:ss a");
        let fileName = dateTime + "." + ext;
        FileSaver.saveAs(url, fileName);
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  const handleShareBrochure = async () => {
    setIsLoader(true);
    let url = "";
    let currentBlob = null;
    const shareTitle = "e-Brochure";
    const shareText = "KStore e-Brochure";
    let fileName = "e-Brochure.pdf";

    try {
      const res = await base64DownloadService(3);
      const {
        base64,
        fileName: sFileName,
        contentType: cType,
        url: resUrl,
      } = parseBase64Response(res);
      if (sFileName) {
        fileName = sFileName.toLowerCase().endsWith(".pdf")
          ? sFileName
          : `${sFileName}.pdf`;
      }
      if (resUrl) url = resUrl;
      if (base64) {
        currentBlob = base64ToBlob(base64, cType);
      }
    } catch (err) {
      console.warn("Base64 brochure download failed, trying fallback:", err);
    }

    // Fallback: if no blob and no url, fetch via QrCodeDownloadService
    if (!currentBlob && !url) {
      try {
        const res = await QrCodeDownloadService();
        url = res?.data?.url;
        if (url) {
          let urlArr = url.split(".");
          let ext = urlArr[urlArr.length - 1] || "pdf";
          fileName = `e-Brochure.${ext}`;
        }
      } catch (err) {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Failed to load e-Brochure");
        }
        setIsLoader(false);
        return;
      }
    }
    setIsLoader(false);

    if (!url && !currentBlob) {
      toast.error("Brochure not found!");
      return;
    }

    if (navigator.share) {
      // 1. Try sharing as a PDF file attachment first
      if (currentBlob) {
        try {
          const file = new File([currentBlob], fileName, {
            type: "application/pdf",
          });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            await navigator.share({
              files: [file],
              title: shareTitle,
              text: shareText,
            });
            return;
          }
        } catch (err) {
          if (err?.name === "AbortError") {
            return;
          }
          console.warn("File share failed, falling back to URL share:", err);
        }
      }

      // 2. Fallback: share as URL if file sharing is not supported by browser
      if (url) {
        try {
          await navigator.share({
            title: shareTitle,
            text: shareText,
            url: url,
          });
          return;
        } catch (err) {
          if (err?.name === "AbortError") {
            return;
          }
          console.error("Native share error:", err);
          toast.error("Unable to open share prompt");
          return;
        }
      }
    } else {
      if (url && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        toast.success("Brochure link copied to clipboard!");
      } else {
        toast.error(
          "Sharing is only supported on mobile devices with HTTPS or a supported browser."
        );
      }
    }
  };

  const handleupiQrCode = () => {
    setIsLoader(true);
    UPIQrCodeService()
      .then((res) => {
        if (res.data.status === 1) {
          let url = res.data.url;
          let urlArr = url.split(".");
          let ext = urlArr[urlArr.length - 1];
          let dateTime =
            moment().format("DD-MM-YYYY") + "," + moment().format("hh:mm:ss a");
          let fileName = dateTime + "." + ext;
          FileSaver.saveAs(url, fileName);
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.detail) {
          toast.error(err.response.data.detail[0].msg, { type: "error" });
        } else {
          toast.error("Something went wrong!!");
        }
      })
      .finally(() => setIsLoader(false));
  };

  return (
    <>
      <Loader isLoader={isLoader} />
      {showBrochureModal ? (
        <BrochureActionModal
          isOpen={showBrochureModal}
          onHide={() => setShowBrochureModal(false)}
          onDownload={handleQrcode}
          onShare={handleShareBrochure}
        />
      ) : null}
      {showWarning ? (
        <Confirmation
          isOpen={showWarning}
          onHide={() => setShowWarning(false)}
          onSucess={() => {
            navigate("/store/subscription/plans");
            setShowWarning(false);
          }}
          isConfirmation={true}
          successBtn="Go to Plans"
          content={planActiveText}
          title="Plan Expired"
        />
      ) : null}
      <div
        onClick={() => handleService(props.data.name)}
        className={Styles.parentContainer}
      >
        <div className={Styles.bg}>
          <img className={Styles.img} src={props.data.img} alt="service" />
        </div>

        <p className={Styles.serviceDescription + " contentFont"}>
          {props.data.name}
        </p>
      </div>
    </>
  );
}
